(function () {
  if (window.FarmexDescuentos) return;

  const USAR_API_LOCAL = true;
  const FARMEX_API_BASE = 'https://services.farmex.cl';
  const NGROK_API_BASE = 'https://1287-190-215-82-18.ngrok-free.app';
  const API_NEGOTIATED_URL = 'https://services.farmex.cl/product/getNegotiatedPrices/';
  const CAMPANIA_CLUB_FARMEX = 'Club Farmex';

  const CAMPANIAS_LOGOS = {
    Fonasa: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/fonasa_defee691-b640-4e6d-9e4b-c524b0d5694c.png?v=1767964667',
    Metlife: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/metlife_logo.png?v=1771338125',
    'Receta Solidaria': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/receta-solidaria.svg?v=1771339448',
    'Seguros SURA': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/seguros-sura.png?v=1771343582',
    'Mujer Artemisa': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/mujer-artemisa_0f5683a2-fbdd-4ab2-be25-03ab196d21e2.png?v=1771342444',
    BanMedica: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/banmedica_6376cc71-7270-4b79-b685-b8323ea9013f.png?v=1771339711',
    VidaTres: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/vidatres.png?v=1771339837',
    Consorcio: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/consorcio_45518966-8488-44ff-8a95-35ef0961690c.png',
    Sermecoop: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/sermecoop_6ef62b5a-dcb8-4743-a4f8-3166eb012546.png?v=1771343988',
    'Chile Salud': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/logo-chilesalud.png?v=1742564337',
    MiaHealth: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/Mia-Health_5b47e5e6-0300-4115-bc46-eaed0a53cf98.png?v=1743774110',
    HelpVidaActiva: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/Help.jpg?v=1771950982',
    'Club Farmex': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/LogoClubFarmex2.png?v=1792609694'
    //Pluxee: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/pluxee_8ade09c4-c480-4646-a74f-ee5cf2c8ba75.png'
  };

  function clubFarmexHabilitado() {
    return window.CLUB_FARMEX_ENABLED !== false;
  }

  function esCampaniaClubFarmex(nombre) {
    return String(nombre || '')
      .toLowerCase()
      .replace(/[\s_-]/g, '') === 'clubfarmex';
  }

  function getFarmexApiBase() {
    if (typeof window.FARMEX_API_BASE_URL === 'string' && window.FARMEX_API_BASE_URL.trim()) {
      return window.FARMEX_API_BASE_URL.trim().replace(/\/$/, '');
    }
    return (USAR_API_LOCAL ? NGROK_API_BASE : FARMEX_API_BASE).replace(/\/$/, '');
  }

  function getFarmexApiHeaders() {
    const headers = { Accept: 'application/json' };
    if (/ngrok-free\.app|ngrok\.io|ngrok\.dev/i.test(getFarmexApiBase())) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }
    return headers;
  }

  function montoClubFarmexTramo(tramo, precioLista) {
    if (!tramo || tramo.tiene_descuento !== true) return 0;

    const override = Number(tramo.monto_override);
    if (override > 0) return override;

    const tipo = String(tramo.tipo_descuento || '');
    const valor = Number(tramo.valor_descuento);
    if (tipo === 'porcentaje' && valor > 0) {
      return Math.max(1, Math.round(precioLista * (valor / 100)));
    }
    if (tipo === 'monto_fijo' && valor > 0) {
      return Math.min(precioLista, Math.max(1, Math.round(valor)));
    }

    const texto = String(tramo.beneficio || '').toLowerCase();
    if (texto.indexOf('despacho') !== -1) return 0;
    const pct = texto.match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (pct) {
      const pctValor = parseFloat(pct[1].replace(',', '.'));
      if (pctValor > 0) return Math.max(1, Math.round(precioLista * (pctValor / 100)));
    }
    const monto = texto.match(/\$\s*([\d.]+)/);
    if (monto) return parseInt(monto[1].replace(/\./g, ''), 10) || 0;
    return 0;
  }

  function itemClubFarmexDesdeFicha(data, sku, precioLista, productId) {
    if (!data || data.hay_club_farmex !== true || !Array.isArray(data.campanias)) return null;

    let mejorPrecio = null;
    let mejorMonto = 0;

    data.campanias.forEach(function (campania) {
      if (!campania || String(campania.aplica_sobre || 'producto').toLowerCase() === 'despacho') return;
      const tramos = Array.isArray(campania.tramos) ? campania.tramos : [];
      const tramo1 = tramos.find(function (tramo) {
        return tramo && Number(tramo.orden) === 1;
      });
      const monto = montoClubFarmexTramo(tramo1, precioLista);
      if (monto <= 0) return;
      const precio = Math.max(0, precioLista - monto);
      if (mejorPrecio == null || precio < mejorPrecio) {
        mejorPrecio = precio;
        mejorMonto = monto;
      }
    });

    if (mejorPrecio == null) return null;

    return {
      campania: CAMPANIA_CLUB_FARMEX,
      precioNegociado: mejorPrecio,
      monto_descuento: mejorMonto,
      codProducto: sku || '',
      idProducto: String(productId || '')
    };
  }

  function fetchClubFarmexFichaItem(productId, sku, precioLista) {
    if (!clubFarmexHabilitado() || (!sku && !productId) || !precioLista) {
      return Promise.resolve(null);
    }

    const params = new URLSearchParams();
    if (sku) params.set('sku', sku);
    if (productId) params.set('id_producto', productId);

    return fetch(getFarmexApiBase() + '/api/club-farmex/ficha?' + params.toString(), {
      method: 'GET',
      headers: getFarmexApiHeaders()
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (data) {
        return itemClubFarmexDesdeFicha(data, sku, precioLista, productId);
      })
      .catch(function () {
        return null;
      });
  }

  function fetchDescuentosCombinados(productId, sku, precioLista) {
    const legacyPromise = fetch(API_NEGOTIATED_URL + productId).then((r) => r.json());

    const cuponesPromise =
      sku && precioLista
        ? fetch(
            `${getFarmexApiBase()}/product/getCuponesCampania?sku=${encodeURIComponent(sku)}&precio_lista=${precioLista}&id_producto=${productId}`,
            { headers: getFarmexApiHeaders() }
          )
            .then((r) => r.json())
            .catch(() => [])
        : Promise.resolve([]);

    return Promise.all([legacyPromise, cuponesPromise]).then(([legacy, cuponesPayload]) => {
      const legacyItems = Array.isArray(legacy) ? legacy : [];
      const cuponesItems = Array.isArray(cuponesPayload?.descuentos)
        ? cuponesPayload.descuentos
        : Array.isArray(cuponesPayload)
          ? cuponesPayload
          : [];

      const campaniasCupones = Array.isArray(cuponesPayload?.campanias) ? cuponesPayload.campanias : [];

      const legacyFiltrado = legacyItems.filter((item) => !campaniasCupones.includes(item?.campania));
      const combinados = [...legacyFiltrado, ...cuponesItems];
      const yaTieneClubFarmex = combinados.some((item) => esCampaniaClubFarmex(item?.campania));

      if (yaTieneClubFarmex || !clubFarmexHabilitado()) {
        return combinados;
      }

      return fetchClubFarmexFichaItem(productId, sku, precioLista).then((itemCf) =>
        itemCf ? combinados.concat(itemCf) : combinados
      );
    });
  }

  function procesarDescuentosVisibles(myJson) {
    if (!Array.isArray(myJson) || myJson.length === 0) return [];

    const result = [];
    const metlifeAgregado = new Set();
    const recetaSolidaria = [];

    myJson.forEach((item) => {
      if (!item?.campania || item.precioNegociado == null || item.precioNegociado === '') return;
      if (esCampaniaClubFarmex(item.campania) && !clubFarmexHabilitado()) return;
      if (!CAMPANIAS_LOGOS[item.campania] && !esCampaniaClubFarmex(item.campania)) return;

      const precioNegociado = Number(item.precioNegociado);
      if (Number.isNaN(precioNegociado) || precioNegociado < 0) return;

      const campania = esCampaniaClubFarmex(item.campania) ? CAMPANIA_CLUB_FARMEX : item.campania;
      if (!CAMPANIAS_LOGOS[campania]) return;

      if (campania === 'Metlife') {
        if (metlifeAgregado.has('Metlife')) return;
        metlifeAgregado.add('Metlife');
      }

      if (campania === 'Receta Solidaria') {
        recetaSolidaria.push(precioNegociado);
        return;
      }

      result.push({
        campania: campania,
        precioNegociado: precioNegociado
      });
    });

    if (recetaSolidaria.length > 0) {
      result.push({
        campania: 'Receta Solidaria',
        precioNegociado: Math.min(...recetaSolidaria)
      });
    }

    return result;
  }

  function obtenerMenorPrecioNegociado(productId, sku, precioLista, callback) {
    fetchDescuentosCombinados(productId, sku, precioLista)
      .then((items) => {
        const visibles = procesarDescuentosVisibles(items);

        if (!visibles.length) {
          callback(null);
          return;
        }

        const menor = visibles.reduce((a, b) =>
          b.precioNegociado < a.precioNegociado ? b : a
        );

        callback(menor);
      })
      .catch(() => callback(null));
  }

  function formatNumber(value) {
    return Number(value).toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP'
    });
  }

  function pintarItem(grid, campania, precio) {
    const logo = CAMPANIAS_LOGOS[campania];
    if (!logo) return;

    const div = document.createElement('div');
    div.className = 'logo-item-cp';
    div.innerHTML = `
      <img src="${logo}" alt="${campania}">
      <p>${formatNumber(precio)}</p>
    `;

    grid.appendChild(div);
  }

  function renderDescuentosGrid(contenedor, myJson) {
    if (!contenedor || !Array.isArray(myJson) || myJson.length === 0) return;

    contenedor.innerHTML = `
      <div class="logos-section-cp">
        <h2 id="ofertas">Descuentos</h2>
        <p>
          <span class="color-red">Importante:</span>
          Para obtener tu descuento, recuerda ingresar tu RUT durante el proceso de pago.
        </p>
        <div class="logos-grid-cp" id="logosGridCp"></div>
      </div>
    `;

    const grid = document.getElementById('logosGridCp');
    const visibles = procesarDescuentosVisibles(myJson);

    visibles.forEach((item) => {
      pintarItem(grid, item.campania, item.precioNegociado);
    });
  }

  function formatPrecioConvenio(precio) {
    return Number(precio).toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    });
  }

  function getVariantData(el) {
    const variant = window.PRODUCT_VARIANT || {};
    return {
      sku: el.dataset.sku || variant.sku || '',
      precioLista: Number(el.dataset.precioLista) || Number(variant.price) || 0
    };
  }

  function initPrecioConvenioUI() {
    const fichaElements = document.querySelectorAll('#MejorPrecioConvenio, .mejor-precio-convenio');
    const cardElements = document.querySelectorAll('.precio-convenio[data-product-id]');

    fichaElements.forEach((el) => {
      if (el.dataset.loaded === 'true') return;

      const productId = el.dataset.productId;
      const precioNormal = Number(el.dataset.precioNormal);
      const { sku, precioLista } = getVariantData(el);

      if (!productId || !precioNormal) return;

      el.dataset.loaded = 'true';

      obtenerMenorPrecioNegociado(productId, sku, precioLista, (menor) => {
        if (!menor) {
          el.style.display = 'none';
          return;
        }

        const precioNegociado = Number(menor.precioNegociado);
        if (precioNegociado >= precioNormal) return;

        const convenioEl = el.querySelector('.convenio');
        if (convenioEl) {
          convenioEl.textContent = formatPrecioConvenio(precioNegociado);
        }
      });
    });

    cardElements.forEach((el) => {
      if (el.dataset.loaded === 'true') return;

      const productId = el.dataset.productId;
      const precioNormal = Number(el.dataset.precioNormal);
      const { sku, precioLista } = getVariantData(el);

      if (!productId || !precioNormal) return;

      el.dataset.loaded = 'true';

      obtenerMenorPrecioNegociado(productId, sku, precioLista, (menor) => {
        if (!menor) return;

        const precioNegociado = Number(menor.precioNegociado);
        if (precioNegociado >= precioNormal) return;

        el.innerHTML = `
          <p class="precio-convenio-texto">
            Mejor precio convenio: ${formatPrecioConvenio(precioNegociado)}
          </p>
        `;
      });
    });
  }

  function bootPrecioConvenioUI() {
    initPrecioConvenioUI();

    if (!window.__farmexPrecioConvenioObserver) {
      window.__farmexPrecioConvenioObserver = new MutationObserver(initPrecioConvenioUI);
      window.__farmexPrecioConvenioObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  window.FarmexDescuentos = {
    CAMPANIAS_LOGOS,
    fetchDescuentosCombinados,
    procesarDescuentosVisibles,
    obtenerMenorPrecioNegociado,
    renderDescuentosGrid,
    formatNumber,
    initPrecioConvenioUI,
    bootPrecioConvenioUI
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPrecioConvenioUI);
  } else {
    bootPrecioConvenioUI();
  }
})();
